import type { Result } from '@schibsted-nmp/search-frontend-clients/suggest';
import React from 'react';

type ResultHitsProps = {
    result: Result;
};

export function ResultHits(props: ResultHitsProps) {
    const { result } = props;

    let hits;

    if (result.info2) {
        hits = result.info2;
    } else if (result.hits) {
        hits = `(${result.hits
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} treff)`;
    }

    return hits ? <span className="text-s s-text-subtle">{hits}</span> : null;
}
